// Use the resize observer to watch for changes in the sticky bar height to adjust the margin appropriately
var cartStickyBarSetup = () => {
    var cartStickyBar = document.querySelector('.cart-sticky-bar');
    var cartStickyBarContainer = document.querySelector('.cart-sticky-bar-container');

    if (cartStickyBar) {
        var resizeObserver = new ResizeObserver((entries) => {
            for (var entry of entries) {
                var newHeight = entry.borderBoxSize[0].blockSize.toString() + 'px';
                cartStickyBarContainer.style.marginBottom = newHeight;
            }
        })

        resizeObserver.observe(cartStickyBar);
    }
}

document.addEventListener('DOMContentLoaded', cartStickyBarSetup);